import { asset } from './asset.js';
// catalog.json, fetched at most once per page (spec §13.3) — by the catalog view or the weight select, whichever needs
// it first. A failed fetch is not remembered: the next caller retries. `peekCatalog()`: the list if it is here already,
// else null — it never fetches (the weight select of a bundled font asks only this).
let pending = null, list = null;
export function loadCatalog() {
  pending ??= fetch(asset('fonts/catalog.json'))
    .then((r) => { if (!r.ok) throw new Error('catalog ' + r.status); return r.json(); })
    .then((l) => { if (!Array.isArray(l)) throw new Error('catalog: not a list'); list = l; return l; })   // a 2xx body that is not the list is a failed catalog, as the worker's is (I5; the final review's M5)
    .catch((e) => { pending = null; throw e; });
  return pending;
}
export const peekCatalog = () => list;
